export default __webpack_public_path__ + "./images/al.8ea33844.png";